module.exports = __webpack_public_path__ + "img/icon-discount-coupon.19908163.svg";